import { useState } from "react";
import { X, AlertTriangle } from "lucide-react";

export default function RejectModal({ open, onClose, onReject }) {
  const [reason, setReason] = useState("");

  if (!open) return null;

  const handleReject = () => {
    if (reason.trim().length >= 20) {
      onReject(reason.trim());
      setReason("");
      onClose();
    }
  };

  const currentLength = reason.trim().length;
  const isValid = currentLength >= 20;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 440 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: "#fef2f2", border: "1.5px solid #fca5a5", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <AlertTriangle size={17} color="#d94f4f" />
            </div>
            <div style={{ fontFamily: "'Google Sans Flex',sans-serif", fontWeight: 700, fontSize: 17, color: "#062830" }}>Reject Product</div>
          </div>
          <button className="btn btn-g btn-xs" onClick={onClose}><X size={14} /></button>
        </div>
        <div style={{ fontSize: 13.5, color: "#0C6170", marginBottom: 14 }}>Please provide a reason for rejecting this product:</div>
        <textarea
          className="inp"
          rows={4}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Enter rejection reason (minimum 20 characters)..."
          style={{ resize: "vertical", marginBottom: 8 }}
        />
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <span style={{ fontSize: 11.5, color: currentLength > 0 && !isValid ? "#b91c1c" : "#0C617099" }}>
            {currentLength > 0 && !isValid 
              ? `Requires at least ${20 - currentLength} more characters` 
              : "Rejection note requires at least 20 characters"}
          </span>
          <span style={{ fontSize: 11.5, color: isValid ? "#0f766e" : "#b91c1c", fontWeight: "600" }}>
            {currentLength} / 20
          </span>
        </div>
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button className="btn btn-g btn-sm" onClick={onClose}>Cancel</button>
          <button className="btn btn-d btn-sm" onClick={handleReject} disabled={!isValid}>Reject</button>
        </div>
      </div>
    </div>
  );
}

